export const BASIC_POKEMON = 'basic_pokemon';
export const STAGE_2 = 'stage_2';
export const STAGE_1 = 'stage_1';
export const POKEMON = 'pokemon';
export const TRAINER = 'trainer';
export const BASIC_ENERGY = 'basic_energy';
export const ENERGY = 'energy';
